import React from 'react' 
import LinkMedia from './LinkMedia'
import SettingsSideNav from './SettingsSideNav'

function Settings() {
  const sideNav={
    padding: "10px 15px 0",
    height: "100%",
    boxSizing: "border-box"
  }
  return (
    <div className='flex'>
    <div style={{ flex: '1 1 280px', textAlign:'left' }}>
      <div style={sideNav}>
  <SettingsSideNav />
  </div>
  </div>
  
  </div>
  )
}

export default Settings